import axios from "../../utils/axios2";
import router from '@/router/index';
export default  {

    namespaced: true,

    state: {
        msg: "hello",
        loginErrorMessage: null,
        api_token: localStorage.getItem('api_token') || null,
        loggedInUser: null,
        workshopId: Number(localStorage.getItem('workshopId')) || null,
        authorizations: null
    },

    getters: {
        isLoggedin(state) {
            if(state.api_token) return true;
            else return false;
        }   
    },

    mutations: {
        setLoginErrorMessage(state, payload) {
            state.loginErrorMessage = payload;
        },
        clearLoginErrorMessage(state) {
            state.loginErrorMessage = null;
        },
        setApiToken(state, payload) {
            state.api_token = payload;
        },
        clearApiToken(state) {
            state.api_token = null;
        },
        setLoggedInUser(state, payload) {
            state.loggedInUser = payload;
        },
        clearLoggedInUser(state) {
            state.loggedInUser = null;
        },
        setWorkshopId(state, payload) {
            state.workshopId = payload;
        },
        clearWorkshopId(state) {
            state.workshopId = null;
        },
        setAuthorizations(state, payload) {
            state.authorizations = payload;
        } 
    },

    actions: {
        login({commit}, payload) {
            return new Promise((resolve, reject) => {
                axios.request({
                    method: "post",
                    url: 'login',
                    data: payload,
                }).then((response) => {
                        let api_token = response.data.api_token;
                        let workshopId = response.data.workshop_id;
                        localStorage.setItem('api_token', api_token);
                        commit("setApiToken", api_token);
                        localStorage.setItem('workshopId', workshopId);
                        commit("setWorkshopId", workshopId);
                        resolve();
                }).catch((error) => {
                        commit('setLoginErrorMessage', error.response.data.message);
                        reject();
                })
            })
        },
        clearLoginErrorMessage({commit}) {
            commit('clearLoginErrorMessage');
        },
        logout({commit}) {
            localStorage.removeItem('api_token');
            commit('clearApiToken');
            commit('clearLoggedInUser');
            localStorage.removeItem('workshopId');
            commit('clearWorkshopId');
            router.push('/auth/login');
        },
        getCurrentUser({commit, rootState}) {
            return new Promise((resolve) => {
                axios.request({
                    method: "get",
                    url: 'current-user',
                    headers: {Authorization: `Bearer ${rootState.authentication.api_token}`}
                }).then((response) => {
                    commit('setLoggedInUser', response.data);
                    resolve();
                });
            })
        },
        fetchAuthorizations({commit, rootState}, payload) {
            return new Promise((resolve, reject) => {
                axios.request({
                    method: "get",
                    url: `authorizations?workshop_id=${payload}`,
                    headers: {Authorization: `Bearer ${rootState.authentication.api_token}`}
                })
                .then(response => {
                    commit("setAuthorizations", response.data);
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.response.data);
                });
            });
        },
        changeWorkshop({dispatch, commit}, workshopId) {
            return new Promise(resolve => {
                localStorage.setItem('workshopId', workshopId);
                commit("setWorkshopId", workshopId);
                dispatch("fetchAuthorizations", workshopId)
                    .then(() => {
                        resolve();        
                    });
            });
        }
    }
}